import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { TableComponent } from './shared/';
import { LoginComponent } from './login/login.component';

//guards
import { UnsavedChangesGuard } from './shared/unsaved-guard/unsaved-changes.guard';
import { AuthGuard } from './core/guards/auth.guard';

// TODO: Change to news.module
import { NewsComponent } from './noticias/news.component';
import { NewsListComponent } from './noticias/news-list/news-list.component';
import { NewsFormComponent } from './noticias/news-form/news-form.component';
import { NewsResolver } from './noticias/shared/news.resolver';

import { LoginImageComponent } from './loginImage/loginimage.component';

import { UsersComponent } from './users/users.component';
import { UsersListComponent } from './users/users-list/users-list.component';

import { EmployeesListComponent } from './employees/employees-list/employees-list.component';
import { EmployeesComponent } from './employees/employees.component';
import { ForumComponent } from './forum/forum.component';



const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent},
  // TODO: Change to news.module
  { path: 'news',  component: NewsComponent,
    canActivate:[AuthGuard],
    children: [
      { path: '', component: NewsListComponent },
      // { path: "new", component: NewsFormComponent, canDeactivate:[UnsavedChangesGuard] },
      {
        path: ':id',
        component: NewsFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        resolve: {
          news: NewsResolver
        }
      }
  ]},
  { path: 'accessories', canActivate:[AuthGuard], loadChildren: 'app/accessories/accessories.module#AccessoriesModule' },
  { path: 'users', canActivate:[AuthGuard], loadChildren: 'app/users/users.module#UsersModule' },
  { path: 'usersapp', canActivate:[AuthGuard], loadChildren: 'app/users-app/users-app.module#UsersAppModule' },
  { path: 'features', canActivate:[AuthGuard], loadChildren: 'app/categories/categories.module#CategoriesModule' },
  { path: 'colors', canActivate:[AuthGuard], loadChildren: 'app/colors/colors.module#ColorsModule' },
  { path: 'compare', canActivate:[AuthGuard], loadChildren: 'app/compare/compare.module#CompareModule' },
  { path: 'comparativeitems', canActivate:[AuthGuard], loadChildren: 'app/comparativeitems/comparativeitems.module#ComparativeItemsModule'},
  { path: 'dashboard', canActivate:[AuthGuard], loadChildren: 'app/dashboard/dashboard.module#DashboardModule' },
  { path: 'sellers', canActivate:[AuthGuard], loadChildren: 'app/sellers/sellers.module#SellersModule'},
  // { path: 'dashboard', canActivate:[AuthGuard], loadChildren: 'app/dashboard/dashboard.module#DashboardModule' },
  { path: 'vehiclenews', canActivate:[AuthGuard], loadChildren: 'app/vehiclenews/vehiclesnews.module#VehiclesNewsModule'},
  { path: 'vehicle', canActivate:[AuthGuard], loadChildren: 'app/vehicles/vehicles.module#VehiclesModule' },
  { path: 'versions', canActivate:[AuthGuard], loadChildren: 'app/versions/versions.module#VersionsModule' },
  { path: 'forum', canActivate:[AuthGuard], component: ForumComponent },
  { path: 'push', canActivate:[AuthGuard], loadChildren: 'app/push/push.module#PushModule' },
  { path: 'homeimage', canActivate:[AuthGuard], loadChildren: 'app/homeImage/homeImage.module#HomeImageModule' },
  { path: 'loginimage', component: LoginImageComponent },
  { path: 'maisvw', canActivate:[AuthGuard], loadChildren: 'app/mais-vw/mais-vw.module#MaisVwModule' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts